import { render, staticRenderFns } from "./Sanitary.vue?vue&type=template&id=45511bf4&"
import script from "./Sanitary.vue?vue&type=script&lang=js&"
export * from "./Sanitary.vue?vue&type=script&lang=js&"
import style0 from "./Sanitary.vue?vue&type=style&index=0&id=45511bf4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports